import * as React from 'react';

function SvgInvoice(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M18.455 2c.853.001 1.544.672 1.545 1.5v18.75c0 .414-.346.75-.773.75h-.772a.78.78 0 01-.619-.3l-1.7-2.2-1.7 2.2a.817.817 0 01-1.236 0l-1.7-2.2-1.7 2.2a.817.817 0 01-1.236 0l-1.7-2.2-1.7 2.2a.78.78 0 01-.619.3h-.772A.762.762 0 013 22.25V3.5C3 2.672 3.692 2 4.545 2zm0 1.5H4.545V21l1.7-2.2a.817.817 0 011.236 0l1.7 2.2 1.7-2.2a.817.817 0 011.236 0h.001l1.7 2.2 1.7-2.2a.817.817 0 011.236 0l1.7 2.2V3.5zm-1.546 9V14h-1.545v-1.5h1.545zm-4.636 0V14H6.09v-1.5h6.182zm4.636-3V11h-1.545V9.5h1.545zm-4.636 0V11H6.09V9.5h6.182zm4.636-3V8H6.091V6.5h10.818z" />
    </svg>
  );
}

export default SvgInvoice;
